import React, { createContext, useContext, useState, useEffect } from "react";
import { translate } from "../lib/publicTranslations";

export const LANGUAGE_KEY = "techdishes.publicLanguage";
const PublicLanguage = createContext({ language: "en", setLanguage: () => {} });
export function PublicLanguageProvider({ children }) {
  useEffect(() => () => { document.documentElement.lang = "en"; }, []);
  const [articleRoutes, setArticleRoutes] = useState(null);
  const [language, updateLanguage] = useState(() => {
    if (window.location.pathname.startsWith("/id/")) return "id";
    try { return localStorage.getItem(LANGUAGE_KEY) === "id" ? "id" : "en"; }
    catch { return "en"; }
  });
  const setLanguage = (value) => {
    if (!["en", "id"].includes(value)) return;
    updateLanguage(value);
    try { localStorage.setItem(LANGUAGE_KEY, value); } catch { /* Storage can be disabled. */ }
  };
  return <PublicLanguage.Provider value={{ language, setLanguage, articleRoutes, setArticleRoutes }}>{children}</PublicLanguage.Provider>;
}
export function usePublicLanguage() {
  const context = useContext(PublicLanguage);
  return { ...context, t: (text) => translate(text, context.language) };
}
